import { getFullPageLoadContext } from './navigation_policy'

const MAX_WAIT_MS = 2000

let navigationPending = false

const isEnabled = function () {
	return !!(
		layData.navigation_policy &&
		layData.navigation_policy.enabled &&
		layData.navigation_policy.hardNavigationWaitUntil
	)
}

const assignLocation = function (href) {
	if (window.location && typeof window.location.assign === 'function') {
		window.location.assign(href)
	} else {
		window.location.href = href
	}
}

const navigate = function (href, page, link) {
	if (!isEnabled()) return false

	const boundary = getFullPageLoadContext(page, href)
	if (!boundary.fromBlocked && !boundary.toBlocked) return false

	if (navigationPending) return true
	navigationPending = true
	document.documentElement.classList.add('lay-hard-navigation-pending')

	const pending = []
	let acceptingPromises = true
	const context = {
		href: href,
		link: link || null,
		page: page || null,
		fromBlocked: boundary.fromBlocked,
		toBlocked: boundary.toBlocked,
		reason: 'navigation-policy',
		waitUntil: function (promise) {
			if (!acceptingPromises) {
				throw new Error('beforehardnavigation.waitUntil() must be called synchronously while the event is emitted.')
			}
			pending.push(Promise.resolve(promise))
		},
	}

	try {
		window.laytheme.emit('beforehardnavigation', context)
	} catch (error) {
		// A site listener must never prevent the requested navigation.
	}
	acceptingPromises = false

	let didNavigate = false
	let timeoutId = null
	const finish = function () {
		if (didNavigate) return
		didNavigate = true
		if (timeoutId !== null) {
			window.clearTimeout(timeoutId)
		}
		assignLocation(href)
	}

	if (pending.length === 0) {
		finish()
		return true
	}

	const timeout = new Promise(function (resolve) {
		timeoutId = window.setTimeout(resolve, MAX_WAIT_MS)
	})
	Promise.race([Promise.allSettled(pending), timeout]).then(finish, finish)
	return true
}

const hard_navigation_transition = {
	navigate: navigate,
}

export { MAX_WAIT_MS, navigate }
export default hard_navigation_transition
